<template>
  <v-layout
    row
    align-center
    :style="myLayoutStyle"
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >

      <v-progress-linear :value="progress_val" v-if="rid==777"></v-progress-linear> <!-- gzf 2022-8-2 -->

      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-card-text v-if="this.status === 1">
          <!-- gzf 2022-8-2 -->
          <h3 :style="titleStyle" v-if="rid!=777">{{ msg }}</h3>
          <div :style="titleStyle" style="text-align:center;margin-top:20px;" v-if="wait_show && rid==777">
            <div style="margin-top:10px">
              <v-icon style="font-size: 60px;">fas fa-circle-notch fa-spin large</v-icon>
            </div>
            <h3 style="margin-top:10px">{{ processing }}</h3>
            <h3 style="margin-top:10px">Please do not close this page</h3>
            <h3 style="margin-top:10px">If you see this page longer than 1 minute,please contact ourstaff.</h3>
          </div>

        </v-card-text>
        <v-card-text v-else-if="this.status === 0">
          <h3 :style="titleStyle">{{ $t('payment_fail') }}</h3>
          <v-btn
            block
            dark
            large
            class="btn"
            :color="theme.btn_color_primary"
            @click="checkout"
          >
            <v-layout row>
              <v-flex
                xs12
                class="text-xs-center"
              >
                Go back to checkout
              </v-flex>
            </v-layout>
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- gzf 2022-8-2 -->
      <v-card
        flat
        v-if="results_success_show"
        class="mx-auto"
        elevation="0"
        style="width:95%;margin-top:50px;text-align:center;"
      >
        <div style="position: relative;top:-40px;">
          <div style="margin-top:10px;display: flex;justify-content: center;">
            <div style="color:#fff;background-color:#54ab7b;width:90px;height:90px;text-align:center;font-size:60px;border-radius: 50%;line-height: 90px;">✓</div>
          </div>
          <div style="color:#54ab7b;font-size:1.6rem;text-align:center;">Order Confirmed</div>
          <v-card-text>
            <div style="color:rgba(0,0,0,.5);font-size:.9rem;">Your order has been placed success</div>
          </v-card-text>
        </div>
      </v-card>
      <v-card
        flat
        v-if="results_fail_show"
        class="mx-auto"
        elevation="0"
        style="width:95%;margin-top:50px;text-align:center;"
      >
        <div style="position: relative;top:-45px;">
          <div style="margin-top:10px;display: flex;justify-content: center;">
            <div style="color:#fff;background-color:#B22222;width:90px;height:90px;text-align:center;font-size:60px;border-radius: 50%;line-height: 90px;">✘</div>
          </div>
          <div style="color:rgba(0,0,0,.5);font-size:1.6rem;text-align:center;padding-top:10px">Order Confirm Failed</div>
          <v-card-text>
            <div style="color:rgba(0,0,0,.5);font-size:.9rem;">Your order placed fail</div>
          </v-card-text>
        </div>
      </v-card>
      <v-card
        flat
        v-if="results_proceeding_show"
        class="mx-auto"
        elevation="0"
        style="width:95%;margin-top:50px;text-align:center;"
      >
        <div style="position: relative;top:-45px;">
          <div style="margin-top:10px;display: flex;justify-content: center;">
            <div style="color:#fff;background-color:#fa9e34;width:90px;height:90px;text-align:center;font-size:60px;border-radius: 50%;line-height: 90px;">
              <img style="width: 90px; height: 90px; padding: 0; margin: 0;" src="/assets/order_processing.png" alt="Order Processing">
            </div>
          </div>
          <div style="color:rgba(0,0,0,.5);font-size:1.6rem;text-align:center;padding-top:10px">Your order is proceeding...</div>
          <v-card-text>
            <div style="color:rgba(0,0,0,.5);font-size:.9rem;">Please check with our staff to confirm we have receive your order</div>
          </v-card-text>
        </div>
      </v-card>
      <v-footer
        v-if="rid==777"
        fixed
        app
        inset
        :height="theme.footer_height"
        :color="theme.footer_bg_color"
      >
        <v-btn
          dark
          large
          @click="look_detail"
          class="btn pl-0 pr-0 text-xs-center"
          :color="theme.btn_color_secondary"
          :disabled="look_detail_disabled"
          style="width:90%; margin-left:5%"
        >
          <v-layout row>
            <v-flex
              xs12
              class="text-xs-center"
            >
              Order Detail
            </v-flex>
          </v-layout>
        </v-btn>
      </v-footer>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'payment-view',
  metaInfo () {
    return { title: this.$t('payment') }
  },
  // gzf 2022-8-2
  data () {
    return {
      msg: null,
      results_success_show: false,
      look_detail_disabled: true,
      wait_show: true,
      id_str: '',
      progress_val: 0,
      processing: 'Processing order',
      tiemer_1: null,
      tiemer_2: null,
      tiemer_3: null,
      results_fail_show: false,
      results_proceeding_show: false,
      go_orders: false //2022-8-11 gzf
    }
  },
  computed: {
    ...mapGetters('auth', [
      'user', 'addresses'
    ]),
    ...mapGetters('config', [
      'theme', 'mode', 'restaurants', 'gid', 'rid', 'withQueueNo'
    ]),
    ...mapGetters('order', [
      'activeOrder', 'orders'
    ]),
    ...mapGetters('member', [
      'isMember', 'profile'
    ]),
    ...mapGetters('delivery', [
      'address'
    ]),
    ...mapGetters('cart', [
      'discountInfo'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    titleStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    status () {
      if (this.$route.query.status) {
        return parseInt(this.$route.query.status)
      }
      return null
    },
    refId () {
      if (this.$route.query.refId) {
        return parseInt(this.$route.query.refId)
      }
      return null
    }
  },
  methods: {
    // gzf 2022-8-2
    sessionStorage_empty() {
      sessionStorage.removeItem('api/epay/client_ref/get')
      sessionStorage.removeItem('api/orders/add')
      sessionStorage.removeItem('api/queue')
    },
    get_api_epay_client_ref_get() {
      let that = this
      that.tiemer_1 = setInterval(() => {
        let res = sessionStorage.getItem('api/epay/client_ref/get')
        if (res === '1') {
          that.progress_val += 33
          that.processing = 'Processing order...'
          clearInterval(that.tiemer_1)
          that.get_api_orders_add()
          return
        }
      }, 100);
    },
    get_api_orders_add() {
      let that = this
      that.tiemer_2 = setInterval(() => {
        let res = sessionStorage.getItem('api/orders/add')
        if (res === '1') {
          that.progress_val += 33
          that.processing = 'Processing order success...'
          clearInterval(that.tiemer_2)
          setTimeout(() => {
            that.get_api_queue()
          }, 1000);
          return
        }
      }, 100);
    },
    get_api_queue() {
      let that = this
      that.tiemer_3 = setInterval(() => {
        let res = sessionStorage.getItem('api/queue')
        if (res) that.processing = 'Processing POS...'
        if (res === '1') {
          that.progress_val += 34
          that.processing = 'Processing POS success...'
          clearInterval(that.tiemer_2)
          this.wait_show = false
          this.results_success_show = true
          this.look_detail_disabled = false
          return
        }else{
          that.progress_val += 34
          that.processing = 'Your order is proceeding...'
          // that.processing = 'POS fail'
          clearInterval(that.tiemer_2)
          this.wait_show = false
          this.results_proceeding_show = true
          // this.results_fail_show = true
          return
        }
      }, 100);
    },
    look_detail() {
      this.$bus.$emit('showFullLoading', true)

      // 2022-8-11 gzf
      if (this.go_orders) {
        this.$router.push({ name: 'orders' })
      }else{
        this.$router.push({ name: 'order2', params: { id: this.id_str }})
      }

      this.$bus.$emit('showFullLoading', false)
    },

    // progress_add() {
    //     if (this.progress_val == 100) return
    //     this.progress_val += 25
    //     if(this.progress_val == 25 ) this.processing = 'The first thing'
    //     if(this.progress_val == 50 ) this.processing = 'The second thing'
    //     if(this.progress_val == 75 ) this.processing = 'The third thing'
    //     if(this.progress_val == 100 ) {
    //         this.processing = 'The fourth thing'
    //         this.wait_show = false
    //         this.$bus.$emit('showFullLoading', true)
    //         this.results_success_show = true
    //         this.look_detail_disabled = false
    //         this.$bus.$emit('showFullLoading', false)
    //     }
    // },


    checkout () {
      this.$router.push({ name: 'checkout' })
    },
    async logData () {
      try {
        let content = { ...this.activeOrder, status: this.status, refId: this.refId }
        if (this.isMember) {
          content.member = this.profile
        }
        await axios.post('/api/log', {
          action: 'redirectFromEPay',
          content: content
        })
      } catch (e) { }
    }
  },
  mounted() {
    // gzf 2022-8-2
    if (this.rid == 777) this.get_api_epay_client_ref_get()
  },
  async created () {
    this.sessionStorage_empty() // gzf 2022-8-2
    this.logData()
    if (this.status === 1) {
      this.$store.dispatch('order/resetOrder')
      this.msg = this.$t('wait_processing_order')
      // Always use client ref, to prevent another tab's state.activeOrder is overriden
      if (this.refId) {
        await this.$store.dispatch('order/fetchActiveOrderEpayClientRef', this.refId)
      }
      if (this.activeOrder) {
        await this.$store.dispatch('order/addOrderByClientRef')
        const id = this.activeOrder.id
        if (this.mode.isDelivery && this.user && !this.address.id && this.addresses && this.addresses.length < 3) {
          // Save only if address in used is not from user's addresses and there is no exact same postal code already exist
          const i = this.addresses.findIndex(a => a.postal_code === this.address.postal_code)
          if (i === -1) {
            this.$store.dispatch('auth/addAddress', this.address)
          }
        }
        await this.$store.dispatch('order/fetchActiveQueue')
        if (this.isMember) {
          if (this.activeOrder.queue_no) {
            await this.$store.dispatch('order/fetchOrderPoints', {
              reference_id: this.activeOrder.reference_id,
              transaction_id: this.activeOrder.queue_no
            })
          }
          await this.$store.dispatch('member/fetchProfile')
        } else {
          this.$store.dispatch('cart/resetGuestDetails')
        }
        if (this.mode.isDinein) {
          this.$store.dispatch('changeTable', '')
        }
        // Only reset if there are multiple outlets
        // if (this.restaurants && this.restaurants.length > 1) {
        //   this.$store.dispatch('config/changeRid', 0)
        // }
        this.$store.dispatch('cart/resetCart')
        this.$store.dispatch('cart/resetPickupTime')
        this.$store.dispatch('order/resetPaymentMode')
        this.$store.dispatch('order/resetOrder')
        this.$store.dispatch('removeAllDiscountVoucher')

        if (!this.withQueueNo && this.orders.find(o => parseInt(o.id) === parseInt(id))) {
          // gzf 2022-8-2
          this.id_str = id.toString()
          if (this.rid != 777) this.$router.push({ name: 'order', params: { id: id.toString() }})
        } else {
          // gzf 2022-8-11
          this.go_orders = true
          if (this.rid != 777) this.$router.push({ name: 'orders' })
        }
      } else {
        this.$router.push({ name: 'checkout' })
      }
    } else if (this.status === 0) {
      // make promo code available
      if (this.discountInfo && this.discountInfo.iorder_promo_code_id) {
        await this.$store.dispatch('promo/updatePromoCodeStatusToAvailable', this.discountInfo.iorder_promo_code_id)
      }
      if (this.isMember) {
        await this.$store.dispatch('member/fetchProfile')
      }
    } else {
      this.$router.push({ name: 'menu', params: { gid: this.gid, rid: parseInt(this.rid) }})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/payment.vue